import { render, staticRenderFns } from "./CardTopFranchise.vue?vue&type=template&id=4fdde3bd&scoped=true&"
import script from "./CardTopFranchise.vue?vue&type=script&lang=js&"
export * from "./CardTopFranchise.vue?vue&type=script&lang=js&"
import style0 from "./CardTopFranchise.vue?vue&type=style&index=0&id=4fdde3bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdde3bd",
  null
  
)

export default component.exports